import { SVGProps } from "react"
const RightArrowIos = ({ color }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.00016 4.08001L15.5202 10.6C16.2902 11.37 16.2902 12.63 15.5202 13.4L9.00016 19.92"
      stroke={color || "currentColor"}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default RightArrowIos
